



















































import { Component, Vue, Prop } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import { State } from 'vuex-class';
import { UserState } from '@/store/types';

@Component({
  components: {  },
})
export default class FooterMenu extends Vue {
    // State
    @State('user')
    public user!: UserState | null;

    @Prop()
    public deviceNumber?: string;

    get loggedIn(): boolean {
        return (this.user as UserState).user != null;
    }
    get isDeveloper(): boolean {
        return (this.user && this.user.user
            && this.user.user.roles && this.user.user.roles.indexOf('Developer') > -1) || false;
    }
}
